import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import getBundleGroups from '../selector/getBundleGroups';
import { selectBundleProductAction } from '../slice';

const setBundleProductByProductIdAndCategoryOperation =
  (categoryId: number, productId: number) =>
  (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const availableBundleGroups = getBundleGroups(store);
    let productItemToSelect;
    const bundleGroup = availableBundleGroups.find((bg) => {
      productItemToSelect = bg.items?.find((item) => item.productId === productId);
      return productItemToSelect;
    });

    if (!bundleGroup || !productItemToSelect) {
      return;
    }

    dispatch(
      selectBundleProductAction({
        bundleGroupId: bundleGroup.bundleGroupId,
        useMultipleSelection: bundleGroup.canSelectMultiple,
        productItem: productItemToSelect,
        categoryId,
      }),
    );
  };

export default setBundleProductByProductIdAndCategoryOperation;
